var app = angular.module('directives.mobilePhone', []);

require('./directives/mobilePhone.js');
require('./templates/mobilePhone.html');
require('./stylesheets/index.scss');

module.exports = app;



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/mobilePhone/index.js
 ** module id = 190
 ** module chunks = 1
 **/